import React from "react";
import { ChevronRight } from "lucide-react";

const ReadyToSeeDifference = () => {
  return (
    <section className="py-20 px-3 sm:px-4 lg:px-6 max-w-7xl mx-auto w-full">
      <div className="bg-[#1A73E8] text-white rounded-[2rem]  px-10 md:px-14 lg:px-20 py-5 md:py-7 lg:py-10  flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-16 relative overflow-hidden shadow-2xl">
        {/* Decorative subtle radial gradient behind the graphic if desired */}
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-white/5 rounded-full blur-3xl pointer-events-none" />

        {/* Left Graphic */}
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-end relative z-10">
          <img
            src="/svgs/ready_to.svg"
            alt="SmileReveal Network Orbit"
            width="500"
            height="500"
            loading="lazy"
            className="w-full max-w-md lg:max-w-[500px] object-contain drop-shadow-xl"
          />
        </div>

        {/* Right Content */}
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left space-y-6 lg:space-y-8 relative z-10">
          <h2 className="text-2xl sm:text-3xl font-bold leading-[1.15] tracking-tight">
            Ready to Boost Your Case Acceptance with AI Smile Simulation?
          </h2>
          <p className="text-base text-blue-100 max-w-lg leading-relaxed">
            Join thousands of dental practices using SmileReveal™ to show
            patients their future smile, close more implant cases, and grow
            revenue — without discounting or high-pressure sales.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-6 mt-4 w-full justify-center lg:justify-start">
            <a
              href="https://app.smilereveal.io"
              className="group relative flex items-center justify-center gap-3 rounded-full bg-white px-8 py-4 text-[#1A73E8] text-lg font-bold shadow-lg hover:scale-105 transition-all w-full sm:w-auto overflow-hidden"
            >
              Start Your Free Trial
              <div className="flex items-center text-[#1A73E8]">
                <ChevronRight className="h-4 w-4 opacity-40 group-hover:translate-x-0.5 transition-transform" />
                <ChevronRight className="h-5 w-5 opacity-70 -ml-2.5 group-hover:translate-x-0.5 transition-transform delay-75" />
                <ChevronRight className="h-6 w-6 opacity-100 -ml-3.5 group-hover:translate-x-0.5 transition-transform delay-150" />
              </div>
            </a>
            <div className="flex flex-col text-sm font-medium text-white/90 text-center sm:text-left">
              <span>No credit card required</span>
              <span>Setup in under 5 minutes</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadyToSeeDifference;
